import { render, staticRenderFns } from "./BaseView.vue?vue&type=template&id=5a24c77b&scoped=true&"
import script from "./BaseView.vue?vue&type=script&lang=js&"
export * from "./BaseView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a24c77b",
  null
  
)

export default component.exports